enum BordereauEtat {
  REFUSE = 'SIGNATURE_REFUSEE',
  SIGNE = 'SIGNATURE_RECUE',
  TERMINE = 'TERMINE',
  REJETE = 'REJETE',
  ERREUR = 'ERREUR_VERIF_PARAPHEUR',
  TRAITEMENT_PES_EN_INSTANCE = 'TRAITEMENT_PES_EN_INSTANCE',
  ATTENTE_TRANSMISSION_PARAPHEUR = 'ATTENTE_TRANSMISSION_PARAPHEUR',
  TRANSMIS_PARAPHEUR = 'TRANSMIS_PARAPHEUR',
  PREPARE_TDT = 'PREPARE_TDT',
  TRAITE_DGFIP = 'TRAITE_DGFIP',
}

export default BordereauEtat;
